import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import useSignedUrl from 'utils/hooks/useSignedUrl';

export const SignedDocumentLink = React.forwardRef(
  ({ documentKey, foreignKey, className, children, onClick, ...rest }, ref) => {
    const { t } = useTranslation();
    const { fetchAndOpen, loading } = useSignedUrl();

    const handleClick = (event) => {
      onClick?.(event);
      if (event.defaultPrevented) return;
      fetchAndOpen({ documentKey, foreignKey });
    };

    return (
      <button
        ref={ref}
        type="button"
        {...rest}
        disabled={loading || (!documentKey && !foreignKey)}
        onClick={handleClick}
        className={className}
      >
        {loading ? (
          <span className="flex items-center gap-4">
            <Loader2 className="h-4 w-4 animate-spin" />
            {t('LOADING')}...
          </span>
        ) : (
          children
        )}
      </button>
    );
  },
);

SignedDocumentLink.displayName = 'SignedDocumentLink';
